
import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import CitizenSubmission from '../pages/citizen-submission/page';
import ViewContent from '../pages/citizen-submission/viewContent';
import Blogs from '../pages/blogs/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/citizen-submission',
    element: <CitizenSubmission />,
  },
  {
    path: '/citizen-submission/viewContent',
    element: <ViewContent />,
  },
  {
    path: '/blogs',
    element: <Blogs />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
